import React from 'react';
import { useParams } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';

const NewsDetail = () => {
  const { id } = useParams();

  return (
    <div className="min-h-screen">
      <Header />
      <main className="pt-20 pb-16 min-h-screen">
        <div className="container mx-auto px-4 py-20">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-5xl font-bold text-brown-900 mb-6">News Article {id}</h1>
            <p className="text-xl text-brown-700">This news page will be created soon.</p>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default NewsDetail;

